// @flow

import {Environment} from 'relay-runtime'
import {commitMutation, graphql, } from 'react-relay'

const mutation = graphql`
    mutation PersonEditMutation(
        $input: PersonEditInput!
    ) {
        PersonEdit(input: $input) {
            person {
                id,
            }
        }
    }
`

export function commit(environment: Environment, params: any, callback: (error: ?Error, id: ?string) => void) {
    commitMutation(
        environment, 
        {
            mutation: mutation,
            variables: {
                input: params
            },
            onCompleted: (response) =>{
                console.log(response)
                if (response.error !== null) {
                    callback(response.error, null)
                    return
                }

                callback(null, response.person.id)
            },
            onError: (error) => {
                console.log("error mutating")
                console.log(error)
                callback(error, null)
            },
        })
}


// WEBPACK FOOTER //
// src/mutations/PersonEditMutation.js